export default __webpack_public_path__ + "static/media/mentor-6.52bf6db8.png";